var cart_note_delay = (function () {
  var timer = 0
  return function (callback, ms) {
    clearTimeout(timer)
    timer = setTimeout(callback, ms)
  }
})()

const Minicart = {
  hasSubscription: false,

  init: function () {
    $.getJSON("/cart.js", function (cart) {
      // console.log(cart);
      window.ned_cart = cart
      Minicart.checkForGift(cart, false)
    })

    $("body").on("click", ".minicart_toggle", function (e) {
      e.preventDefault()
      if ($("body").hasClass("template-cart")) return

      if ($("#minicart").hasClass("open")) {
        $("#minicart").removeClass("open")
        $("#minicart__overlay").fadeOut(250, function () {
          $("#beacon-container").show()
        })
        $("body").css("overflow", "")
      } else {
        $("#minicart").addClass("open")
        $("#minicart__overlay").fadeIn(250)
        $("#beacon-container").hide()
        $("body").css("overflow", "hidden")
      }
    })

    $("body").on("click", "#minicart__overlay", function (e) {
      $("#minicart").removeClass("open")
      $("#minicart__overlay").fadeOut(250, function () {
        $("#beacon-container").show()
      })
      $("body").css("overflow", "")
    })

    $("body").on("keyup", ".minicart .cart_note", function (e) {
      var cart_note = $(this).val()
      cart_note_delay(function () {
        var updates = {}
        $.post(
          "/cart/update.js",
          { note: cart_note },
          function (cart) {
            // console.log(cart);
          },
          "json"
        )
      }, 500)
    })

    document.addEventListener("rebuy.add", function () {
      $.getJSON("/cart.js", function (e) {
        Minicart.updateMinicart(e, true)
      })
    })

    document.addEventListener("rebuy.remove", function () {
      $.getJSON("/cart.js", function (e) {
        Minicart.updateMinicart(e, true)
      })
    })

    document.addEventListener(
      "quizKitAddToCartSuccess",
      function (e) {
        $.getJSON("/cart.js", function (e) {
          Minicart.updateMinicart(e, true)
        })
      },
      false
    )

    $("body").on("click", ".minicart .change_quantity", function (e) {
      e.preventDefault()
      var new_quantity = $(this).attr("data-quantity")
      var $parent = $(this).closest(".item")
      var item_id = $parent.attr("data-item-id")
      var variant_id = $parent.attr("data-variant-id")

      let okToContinue = true
      if (window.ned_cart) {
        window.ned_cart.items.forEach((cartItem) => {
          if (
            cartItem.variant_id == variant_id &&
            cartItem.properties._attribution &&
            cartItem.properties._attribution === "Rebuy Gift with Purchase"
          ) {
            okToContinue = false
          }
        })
      }

      if (!okToContinue) return

      var giftId = false
      var giftId2 = false

      if (window.hellonedGiftCart && window.hellonedGiftCart.enabled) {
        if (
          typeof window.hellonedGiftCart.gift_id !== "undefined" &&
          window.hellonedGiftCart.gift_id !== "false"
        ) {
          giftId = window.hellonedGiftCart.gift_id.toString()
        }
      }

      if (window.hellonedGiftCart2 && window.hellonedGiftCart2.enabled) {
        if (
          typeof window.hellonedGiftCart2.gift_id &&
          window.hellonedGiftCart2.gift_id !== "false"
        ) {
          giftId2 = window.hellonedGiftCart2.gift_id.toString()
        }
      }

      var gifts = [
        { id: giftId, status_name: "gift-item-status" },
        { id: giftId2, status_name: "gift-item2-status" },
      ]

      // upsell items
      if ($(this).closest("form").length >= 1) {
        if (new_quantity <= 0) new_quantity = 1
        var price = $parent.attr("data-price")
        $parent.find("[data-quantity-value]").text(new_quantity)
        $parent.find("[data-quantity-value]").val(new_quantity)
        if ($parent.find("[data-original-line-price]").first()) {
          $parent
            .find("[data-original-line-price]")
            .text(
              "$" + ((price * new_quantity) / 100).toFixed(2).replace(".00", "")
            )
          $parent
            .find("[data-line-price]")
            .text(
              "$" +
                ((price * new_quantity * 0.8) / 100)
                  .toFixed(2)
                  .replace(".00", "")
            )
        } else {
          $parent
            .find("[data-line-price]")
            .text(
              "$" + ((price * new_quantity) / 100).toFixed(2).replace(".00", "")
            )
        }
        $parent
          .find(".plus[data-quantity]")
          .attr("data-quantity", parseInt(new_quantity) + 1)
        $parent
          .find(".minus[data-quantity]")
          .attr("data-quantity", parseInt(new_quantity) - 1)

        // items actual in cart
      } else {
        var data = { quantity: new_quantity, id: variant_id }

        gifts.forEach((gift) => {
          if (item_id === gift.id && parseInt(new_quantity) === 0) {
            localStorage.setItem(gift.status_name, "_efs")
          }
        })

        $.ajax({
          type: "POST",
          url: "/cart/change.js",
          dataType: "json",
          data: data,
          success: function (data) {
            Minicart.checkForGift(data)
          },
        })
      }
    })

    $("body").on(
      "change",
      '.minicart .subscribe-container .switch input[type="checkbox"]',
      function (e) {
        // swap item in cart
        $(".loader-container").css("visibility", "visible")
        $(".loader-overlay").css("visibility", "visible")

        var onetime_id = $(this)
          .closest(".subscribe-container")
          .attr("data-onetime-id")
        var subscription_id = $(this)
          .closest(".subscribe-container")
          .attr("data-subscription-id")
        var variant_id = $(this)
          .closest(".subscribe-container")
          .attr("data-variant-id")
        var line_id = $(this).closest(".item").attr("data-line-id")
        var quantity = parseInt(
          $(this).closest(".item").find("[data-quantity-value]").text()
        )

        // has a onetime, wants a subscription
        var new_variant_id = false
        if ($(this).is(":checked") && variant_id == onetime_id) {
          var new_variant_id = subscription_id
          // has a subscription, wants a onetime
        } else if (!$(this).is(":checked") && variant_id == subscription_id) {
          var new_variant_id = onetime_id
        }

        if (new_variant_id) {
          if (new_variant_id == onetime_id) {
            $(this)
              .closest(".subscribe-container")
              .find(".subscription")
              .addClass("blue")
            $(this)
              .closest(".subscribe-container")
              .find(".onetime")
              .removeClass("blue")

            var properties = {}
          } else {
            $(this)
              .closest(".subscribe-container")
              .find(".subscription")
              .removeClass("blue")
            $(this)
              .closest(".subscribe-container")
              .find(".onetime")
              .addClass("blue")

            var properties = JSON.parse(
              $(this).closest(".subscribe-container").attr("data-properties")
            )
          }

          // console.log(properties);

          var cart
          $.ajax({
            type: "POST",
            url: "/cart/change.js",
            dataType: "json",
            data: { quantity: 0, line: line_id },
            success: function (data) {
              cart = data
              $.ajax({
                type: "POST",
                url: "/cart/add.js",
                dataType: "json",
                data: {
                  items: [
                    {
                      quantity: quantity,
                      id: new_variant_id,
                      properties: properties,
                    },
                  ],
                },
                success: function (data) {
                  // console.log(data);

                  $.ajax({
                    type: "GET",
                    url: "/cart.js",
                    dataType: "json",
                    data: {},
                    success: function (data) {
                      // console.log(data);
                      Minicart.updateMinicart(data)
                    },
                    error: function (a, b, c) {
                      console.error(a)
                      console.error(b)
                      console.error(c)
                    },
                  })
                },
                error: function (a, b, c) {
                  console.error(a)
                  console.error(b)
                  console.error(c)
                },
              })
            },
          })
        }
      }
    )

    $("body").on("click", "#minicart .minicart__footer .button", function (e) {
      if (Minicart.hasSubscription) {
        e.preventDefault()
      }
    })
  },

  checkForGift: function (cart, showCart) {
    let giftItem = false
    let shouldIncludeGift = false
    const giftItemStatus = localStorage.getItem("gift-item-status")
    const excludeCode = "_efs"
    const includeCode = "_ifs"
    const excludeProductIds = []
    const includeProductIds = []
    const t = cart.items_subtotal_price / 100
    let th = 0
    let isGiftEnabledByProducts = false

    // Check if Cart has Subscription product
    Minicart.hasSubscription = false
    cart.items.forEach((cart_item) => {
      if (
        cart_item.properties &&
        cart_item.properties.shipping_interval_frequency !== undefined
      ) {
        Minicart.hasSubscription = true
      }
    })

    if (window.hellonedGiftCart) {
      let giftScript = window.hellonedGiftCart
      let threshold = parseInt(window.hellonedGiftCart.thresh)

      if (!isNaN(threshold)) {
        th = threshold
      }

      if (giftScript.enabled) {
        giftItem = giftScript.gift_id

        let exclude = []
        let include = []

        if (giftScript.exclusion_products !== "") {
          exclude = giftScript.exclusion_products.trim().split(",")
          exclude.forEach((id) => {
            let trimmed = parseInt(id.trim())
            if (trimmed !== giftScript.gift_product_id) {
              excludeProductIds.push(trimmed)
            }
          })
        }

        if (giftScript.products_in_cart.trim() !== "") {
          include = giftScript.products_in_cart.trim().split(",")
          include.forEach((id) => includeProductIds.push(parseInt(id.trim())))
        }

        if (includeProductIds.length > 0) {
          isGiftEnabledByProducts = true
        }
      }
    }

    const excludeProductsInCart = cart.items.filter((o) => {
      return excludeProductIds.includes(o.product_id)
    })

    const giftEnablingProductsInCart = cart.items.filter((o) => {
      return includeProductIds.includes(o.product_id)
    })

    if (isGiftEnabledByProducts) {
      if (
        (t < th && giftEnablingProductsInCart.length > 0) ||
        giftEnablingProductsInCart.length === 0
      ) {
        localStorage.setItem("gift-item-status", includeCode)
      }
    } else {
      if (th !== 0) {
        if (t < th) {
          localStorage.setItem("gift-item-status", includeCode)
        }
      } else {
        if (t === 0) {
          localStorage.setItem("gift-item-status", includeCode)
        }
      }
    }

    if (isGiftEnabledByProducts) {
      if (
        giftEnablingProductsInCart.length > 0 &&
        giftItemStatus !== excludeCode &&
        excludeProductsInCart.length === 0 &&
        t >= th
      ) {
        shouldIncludeGift = true
      }
    } else {
      if (
        giftItemStatus !== excludeCode &&
        excludeProductsInCart.length === 0
      ) {
        shouldIncludeGift = true
      }
    }

    const giftInCart = cart.items.filter((o) => {
      return o.variant_id === giftItem
    })

    if (
      window.hellonedGiftCart &&
      window.hellonedGiftCart.enabled &&
      giftItem &&
      shouldIncludeGift
    ) {
      if (t >= th && giftInCart.length === 0) {
        // console.log("G1/1");

        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          dataType: "json",
          data: {
            items: [
              {
                quantity: "1",
                id: giftItem.toString(),
                properties: {
                  _Resource: "Free Gift Program",
                },
              },
            ],
          },
          success: function (data) {
            $.getJSON("/cart.js", function (cart) {
              // console.log(cart);
              Minicart.checkForGift2(cart, showCart)
            })
          },
        })
      } else {
        // console.log("G1/2");
        Minicart.checkForGift2(cart, showCart)
      }
    } else if (
      window.hellonedGiftCart &&
      window.hellonedGiftCart.enabled &&
      giftItem &&
      !shouldIncludeGift
    ) {
      // console.log("G1/3");
      if (giftInCart.length > 0) {
        var data = { quantity: 0, id: giftItem }
        $.ajax({
          type: "POST",
          url: "/cart/change.js",
          dataType: "json",
          data: data,
          success: function (data) {
            cart = data
            $.getJSON("/cart.js", function (cart) {
              Minicart.checkForGift2(cart, showCart)
            })
          },
        })
      } else {
        // console.log("G1/4");
        Minicart.checkForGift2(cart, showCart)
      }
    } else {
      // console.log("G1/5");
      Minicart.checkForGift2(cart, showCart)
    }
  },

  checkForGift2: function (cart, showCart) {
    let giftItem = false
    let shouldIncludeGift = false
    const excludeCode = "_efs"
    const includeCode = "_ifs"
    const giftItemStatus = localStorage.getItem("gift-item2-status")
    const excludeProductIds = []
    const includeProductIds = []
    const t = cart.items_subtotal_price / 100
    let th = 0
    let isGiftEnabledByProducts = false

    // console.log("Check 2");

    if (window.hellonedGiftCart2) {
      let giftScript = window.hellonedGiftCart2
      let threshold = parseInt(window.hellonedGiftCart2.thresh)

      if (!isNaN(threshold)) {
        th = threshold
      }

      if (giftScript.enabled) {
        giftItem = giftScript.gift_id

        let exclude = []
        let include = []

        if (giftScript.exclusion_products !== "") {
          exclude = giftScript.exclusion_products.trim().split(",")
          exclude.forEach((id) => {
            let trimmed = parseInt(id.trim())
            if (trimmed !== giftScript.gift_product_id) {
              excludeProductIds.push(trimmed)
            }
          })
        }

        if (giftScript.products_in_cart.trim() !== "") {
          include = giftScript.products_in_cart.trim().split(",")
          include.forEach((id) => includeProductIds.push(parseInt(id.trim())))
        }

        if (includeProductIds.length > 0) {
          isGiftEnabledByProducts = true
        }
      }
    }

    const excludeGiftProductsInCart = cart.items.filter((o) => {
      return excludeProductIds.includes(o.product_id)
    })

    const giftEnablingProductsInCart = cart.items.filter((o) => {
      return includeProductIds.includes(o.product_id)
    })

    if (isGiftEnabledByProducts) {
      if (
        (t < th && giftEnablingProductsInCart.length > 0) ||
        giftEnablingProductsInCart.length === 0
      ) {
        localStorage.setItem("gift-item2-status", includeCode)
      }
    } else {
      if (th !== 0) {
        if (t < th) {
          localStorage.setItem("gift-item2-status", includeCode)
        }
      } else {
        if (t === 0) {
          localStorage.setItem("gift-item2-status", includeCode)
        }
      }
    }

    if (isGiftEnabledByProducts) {
      if (
        giftEnablingProductsInCart.length > 0 &&
        giftItemStatus !== excludeCode &&
        excludeGiftProductsInCart.length === 0 &&
        t >= th
      ) {
        shouldIncludeGift = true
      }
    } else {
      if (
        giftItemStatus !== excludeCode &&
        excludeGiftProductsInCart.length === 0
      ) {
        shouldIncludeGift = true
      }
    }

    const giftInCart = cart.items.filter((o) => {
      return o.variant_id === giftItem
    })

    // console.log("G2/0");

    if (
      window.hellonedGiftCart2 &&
      window.hellonedGiftCart2.enabled &&
      giftItem &&
      shouldIncludeGift
    ) {
      // console.log("G2/1");

      if (t >= th && giftInCart.length === 0) {
        // console.log("G2/2");

        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          dataType: "json",
          data: {
            items: [
              {
                quantity: "1",
                id: giftItem.toString(),
                properties: {
                  _Resource: "Free Gift Program",
                },
              },
            ],
          },
          success: function (data) {
            $.getJSON("/cart.js", function (cart) {
              Minicart.updateMinicart(cart, showCart)
            })
          },
        })
      } else {
        // console.log("G2/3");
        Minicart.updateMinicart(cart, showCart)
      }
    } else if (
      window.hellonedGiftCart2 &&
      window.hellonedGiftCart2.enabled &&
      giftItem &&
      !shouldIncludeGift
    ) {
      // console.log("G2/4");

      if (giftInCart.length > 0) {
        // console.log("G2/5");

        const data = { quantity: 0, id: giftItem }
        $.ajax({
          type: "POST",
          url: "/cart/change.js",
          dataType: "json",
          data: data,
          success: function (data) {
            cart = data
            $.getJSON("/cart.js", function (cart) {
              Minicart.updateMinicart(cart, showCart)
            })
          },
        })
      } else {
        // console.log("G2/6");

        Minicart.updateMinicart(cart, showCart)
      }
    } else {
      // console.log("G2/7");

      Minicart.updateMinicart(cart, showCart)
    }
  },

  updateMinicart: function (cart, showCart) {
    window.ned_cart = cart
    // console.log('update minicart');

    $(".cart_item_count").text(cart.item_count)
    $("[data-cart-total]").text(
      "$" + (cart.total_price / 100).toFixed(2).replace(".00", "")
    )

    $(".minicart__items").find(".item:not(#item_model)").remove()

    var $product_upsell = $(".minicart__addons").first()
    var has_upsell = false

    Minicart.hasSubscription = false
    cart.items.forEach((cart_item) => {
      if (
        cart_item.properties &&
        cart_item.properties.shipping_interval_frequency !== undefined
      ) {
        Minicart.hasSubscription = true
      }
    })

    var threshold = parseInt(
      $(".minicart__freeshipping").attr("data-threshold")
    )
    if (cart.total_price >= threshold || Minicart.hasSubscription) {
      $(".minicart__freeshipping").addClass("hide")
      $(".minicart__freeshipping_success").removeClass("hide")
    } else {
      $(".minicart__freeshipping [data-shipping-left]").text(
        "$" +
          ((threshold - cart.total_price) / 100).toFixed(2).replace(".00", "")
      )
      $(".minicart__freeshipping .progress-content").css(
        "width",
        Math.round((cart.total_price / threshold) * 100) + "%"
      )
      $(".minicart__freeshipping").removeClass("hide")
      $('.minicart__freeshipping_success[data-is-member="false"]').addClass(
        "hide"
      )
    }

    for (var k in cart.items) {
      if (
        $product_upsell.length > 0 &&
        cart.items[k].variant_id == $product_upsell.attr("data-id")
      )
        has_upsell = true

      var full_title = cart.items[k].product_title
      var isSubscription = false
      if (
        cart.items[k].properties &&
        cart.items[k].properties.shipping_interval_frequency !== undefined
      ) {
        isSubscription = true
        cart.items[k].handle = cart.items[k].handle.slice(0, -2)
        cart.items[k].url = `/products/` + cart.items[k].handle

        var frequency = cart.items[k].properties.shipping_interval_frequency
        for (var j in cart.items[k].properties) {
          if (
            j.indexOf("_") != 0 &&
            !j.includes("shipping_interval_") &&
            !j.includes("preorder") &&
            !j.includes("original_frequency")
          ) {
            full_title += "<br />" + cart.items[k].properties[j]
          }
        }

        if (
          cart.items[k].variant_title != null &&
          cart.items[k].variant_title != "Default Title"
        ) {
          full_title += "<br />" + cart.items[k].variant_title
        }
      } else if (
        cart.items[k].variant_title != null &&
        cart.items[k].variant_title != "Default Title"
      ) {
        full_title += "<br />" + cart.items[k].variant_title
      }

      var $item_html = $("#item_model").clone()
      $item_html.removeClass("hide")
      $item_html.attr("id", "item-" + cart.items[k].id)
      $item_html.attr("data-item-id", cart.items[k].id)
      $item_html.attr("data-line-id", parseInt(k) + 1)
      $item_html.attr("data-product-id", cart.items[k].product_id)
      $item_html.attr("data-product-handle", cart.items[k].handle)
      $item_html.attr("data-variant-id", cart.items[k].variant_id)
      $item_html.find(".item_image").attr("href", cart.items[k].url)
      $item_html
        .find(".change_quantity.remove")
        .attr("data-quantity", 0)
        .attr("href", "/cart/change?line=" + (parseInt(k) + 1) + "&quantity=0")
      $item_html
        .find(".change_quantity.plus")
        .attr("data-quantity", parseInt(cart.items[k].quantity) + 1)
        .attr(
          "href",
          "/cart/change?line=" +
            (parseInt(k) + 1) +
            "&quantity=" +
            (parseInt(cart.items[k].quantity) + 1)
        )
      $item_html
        .find(".change_quantity.minus")
        .attr("data-quantity", parseInt(cart.items[k].quantity) - 1)
        .attr(
          "href",
          "/cart/change?line=" +
            (parseInt(k) + 1) +
            "&quantity=" +
            (parseInt(cart.items[k].quantity) - 1)
        )
      $item_html
        .find(".item_title")
        .html(full_title)
        .attr("href", cart.items[k].url)
      $item_html.find("[data-quantity-value]").text(cart.items[k].quantity)
      if (cart.items[k].original_line_price != cart.items[k].line_price) {
        $item_html
          .find("[data-original-line-price]")
          .text(
            "$" +
              (cart.items[k].original_line_price / 100)
                .toFixed(2)
                .replace(".00", "")
          )
          .show()
      } else {
        $item_html.find("[data-original-line-price]").hide()
      }
      $item_html
        .find("[data-line-price]")
        .text(
          "$" + (cart.items[k].line_price / 100).toFixed(2).replace(".00", "")
        )

      if (isSubscription) {
        $item_html
          .find(".every-" + frequency)
          .addClass("show")
          .show()
        $item_html.find("[data-original-line-price]").hide()
        Minicart.populateImage(
          cart.items[k].handle,
          $item_html,
          cart.items[k].variant_title
        )
      } else {
        $item_html.find(".item_image > img").attr("src", cart.items[k].image)
      }

      $item_html
        .find(".subscribe-container")
        .attr("data-variant-id", cart.items[k].variant_id)
      var onetime_id = ""
      var subscription_id = ""
      var properties = {}
      $(".minicart-onetime-subscription").each(function () {
        if (
          $(this).attr("data-onetime-id") == cart.items[k].variant_id ||
          ($(this).attr("data-subscription-id") == cart.items[k].variant_id &&
            cart.items[k].properties[$(this).attr("data-option1-name")] ==
              $(this).attr("data-option1-value") &&
            cart.items[k].properties[$(this).attr("data-option2-name")] ==
              $(this).attr("data-option2-value") &&
            cart.items[k].properties[$(this).attr("data-option3-name")] ==
              $(this).attr("data-option3-value"))
        ) {
          onetime_id = $(this).attr("data-onetime-id")
          subscription_id = $(this).attr("data-subscription-id")
          if ($(this).attr("data-option1-name")) {
            properties[$(this).attr("data-option1-name")] =
              $(this).attr("data-option1-value")
            properties["_" + $(this).attr("data-option1-name")] =
              $(this).attr("data-option1-value")
          }
          if ($(this).attr("data-option2-name")) {
            properties[$(this).attr("data-option2-name")] =
              $(this).attr("data-option2-value")
            properties["_" + $(this).attr("data-option2-name")] =
              $(this).attr("data-option2-value")
          }
          if ($(this).attr("data-option3-name")) {
            properties[$(this).attr("data-option3-name")] =
              $(this).attr("data-option3-value")
            properties["_" + $(this).attr("data-option3-name")] =
              $(this).attr("data-option3-value")
          }
          properties["_autoskip_periods"] = $(this).attr("data-autoskip")
        }
      })

      $item_html
        .find(".subscribe-container")
        .attr("data-onetime-id", onetime_id)
      $item_html
        .find(".subscribe-container")
        .attr("data-subscription-id", subscription_id)
      $item_html
        .find(".subscribe-container")
        .attr("data-properties", JSON.stringify(properties))
      if (onetime_id == "" || subscription_id == "") {
        $item_html.find(".subscribe-container").hide()
      }

      if (subscription_id == cart.items[k].variant_id) {
        $item_html
          .find('.subscribe-container input[type="checkbox"]')
          .prop("checked", true)
        $item_html
          .find(".subscribe-container .subscription")
          .removeClass("blue")
        $item_html.find(".subscribe-container .onetime").addClass("blue")
      }

      $(".minicart__items").append($item_html)
    }

    if (has_upsell) {
      $(".minicart__addons").hide()
    } else {
      $(".minicart__addons").show()
    }

    Minicart.populateTags()

    if (showCart) {
      if (window.location.pathname === "/cart") return

      $("#minicart").addClass("open")
      $("#minicart__overlay").fadeIn(250)
      $("#beacon-container").hide()
    }

    $(".loader-container").css("visibility", "hidden")
    $(".loader-overlay").css("visibility", "hidden")
  },

  populateImage: function (handle, $item, variant_title) {
    $.ajax({
      type: "GET",
      url: "/products/" + handle + ".js",
      dataType: "json",
      success: function (data) {
        var image = data.featured_image
        for (var i in data.variants) {
          if (data.variants[i].title == variant_title) {
            if (data.variants[i].featured_image != undefined) {
              image = data.variants[i].featured_image.src
            }

            break
          }
        }

        $item.find(".item_image > img").attr("src", image)
      },
    })
  },

  populateTags: function () {
    $(".minicart__items")
      .find(".item:not(#item_model)")
      .each(function () {
        var product_handle = $(this).attr("data-product-handle")
        var $item = $(this)
        $.ajax({
          type: "GET",
          url: "/products/" + product_handle + ".js",
          dataType: "json",
          success: function (data) {
            var size_tag = ""

            for (var i in data.tags) {
              if (data.tags[i].indexOf("size:") >= 0) {
                size_tag = data.tags[i]
                  .replace("size:", "")
                  .replace("size: ", "")
              }
            }
            $item.find(".size-tag").text(size_tag)
          },
        })
      })
  },
}

export default Minicart
